import ScreenUtils from '@screen';
import styled from 'styled-components';

const SupportDescriptionContainer = styled.div`
  margin-bottom: ${30 * ScreenUtils.widthRatio}px;
`;

export default SupportDescriptionContainer;
